import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found | Car To Cash" description="The page you're looking for can't be found." />
      <section className="mx-auto max-w-xl px-4 sm:px-6 py-32 text-center" data-testid="not-found">
        <p className="font-display text-7xl font-black text-brand-gold">404</p>
        <h1 className="mt-4 font-display text-3xl font-extrabold text-brand-navy">Page not found</h1>
        <p className="mt-3 text-brand-muted">The page you're after doesn't exist or has moved. Let's get you back on track.</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" className="rounded-full bg-brand-navy px-7 py-3.5 font-bold text-white hover:bg-brand-navy2 transition-colors">Home</Link>
          <Link to="/sell-your-car" className="rounded-full bg-brand-gold px-7 py-3.5 font-bold text-brand-navy hover:bg-brand-goldDark transition-colors">Get a price</Link>
        </div>
      </section>
    </>
  );
}
